(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const host = document.querySelector('.cart')?.closest('.shopify-section');
    if (!host) return;

    // 数量の上限は JS で検査する。<input max> にすると、100 以上が入った既存のカートで
    // 購入手続きの送信をブラウザが止めてしまう（フォーム検証）。
    const MAX_QUANTITY = 99;
    const WAIT_MS = 300; // 入力の途中（"2" → "21"）で反映しないための待ち
    const TIMEOUT_MS = 8000; // 応答が返らないときは、通常の遷移に切り替える
    const root = window.Shopify?.routes?.root || '/';

    // Section Rendering API で描き直すセクションの id（DOM の id から shopify-section- を外したもの。
    // template--123__main のように接頭辞まで要る。末尾の "main" だけだと null が返る）
    const keyOf = (el) => el.id.replace(/^shopify-section-/, '');
    const headerHost = document.querySelector('.header')?.closest('.shopify-section');
    const sectionKeys = [keyOf(host), headerHost && keyOf(headerHost)].filter(Boolean);

    let waiting = null; // { key, value, timer }: 入力を確定して、反映を待っている行（要素は持たない。差し替えで消えるため）
    let queue = Promise.resolve(); // 更新は1本のキューで順に行う（並行して走らせない）
    let pending = 0; // 待ちと通信中の更新の数

    const hideUpdateButton = () => {
      const update = host.querySelector('[data-role="update"]');
      if (update) update.hidden = true;
    };
    hideUpdateButton(); // JS が動くときは「更新」を隠す（動かないときは「更新」で通常送信できる）

    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    // 読み上げ用（画面には出ない）
    const announce = (message) => {
      const status = host.querySelector('[data-cart-status]');
      if (!status) return;
      status.textContent = '';
      setTimeout(() => { status.textContent = message; }, 50);
    };

    // 画面に見せる一言。上の一言は読み直したあとの案内だけ、行の一言は入力の誤り（差し替えのたびに消える）
    const showMessage = (message) => {
      const target = host.querySelector('[data-cart-message]');
      if (target) target.textContent = message;
    };
    const showRowMessage = (input, message) => {
      const target = input.closest('.cart__row')?.querySelector('[data-qty-note]');
      if (target) target.textContent = message;
    };

    // 通信に失敗してページを読み直した直後は、そのことを一言で知らせる
    const RELOAD_NOTE = 'カートを読み直しました。内容をご確認ください。';
    try {
      if (sessionStorage.getItem('cart-reloaded')) {
        sessionStorage.removeItem('cart-reloaded');
        showMessage(RELOAD_NOTE);
        announce(RELOAD_NOTE);
      }
    } catch (error) { /* sessionStorage が使えなくても、読み直しは働く */ }

    // 差し替えで消える要素を、差し替え後にもう一度探すための目印。
    // 行は key で探す（行番号は、前の行を削除すると繰り上がって別の行を指してしまう）。
    const anchorOf = (el) => {
      if (el.matches('.cart__qty-input')) return `.cart__qty-input[data-key="${el.dataset.key}"]`;
      if (el.matches('.cart__remove')) return `.cart__remove[data-key="${el.dataset.key}"]`;
      if (el.matches('.cart__product-title')) return `.cart__product-title[data-key="${el.dataset.key}"]`;
      if (el.matches('.cart__checkout')) return '.cart__checkout';
      if (el.matches('.cart__link')) return '.cart__link';
      return '';
    };

    const render = (sections, line, key, quantity, title) => {
      const nextCart = sections?.[keyOf(host)] && parse(sections[keyOf(host)]).querySelector('.cart__container');
      const currentCart = host.querySelector('.cart__container');
      if (!nextCart || !currentCart) throw new Error('render');

      // 差し替える前に、いまフォーカスがあった場所と、打ちかけの値を控える
      const active = document.activeElement;
      const focusFree = !active || active === document.body;
      const focusInCart = !!active && host.contains(active);
      const operated = focusInCart && active.dataset?.key === key; // 操作していた行の数量欄・削除
      const anchor = focusInCart && !operated ? anchorOf(active) : '';
      const typed = anchor && active.matches('.cart__qty-input') ? active.value : null;

      currentCart.replaceWith(nextCart);
      hideUpdateButton();

      const headerKey = headerHost && keyOf(headerHost);
      const nextCount = headerKey && sections[headerKey] && parse(sections[headerKey]).querySelector('.header__cart');
      // ヘッダーには .header__cart が2箇所ある（セルと、スマホの折り畳みメニュー内のリンク）。両方更新する。
      if (nextCount) {
        document.querySelectorAll('.header__cart').forEach((el) => {
          el.textContent = nextCount.textContent.trim();
        });
      }

      // フォーカスの戻し先:
      //  - 操作していた行（数量欄・削除）にあったときは、その位置に来た行の数量欄（行が消えたときは次の行か前の行）
      //  - 更新を待つあいだに別の場所へ進んでいたときは、差し替え後の同じ要素（打ちかけの値も残す）
      //  - フォーカスがカートの外（ヘッダーなど）にあったときは動かさない
      // どの場合も、画面はスクロールさせない。
      const inputs = host.querySelectorAll('.cart__qty-input');
      const same = anchor ? host.querySelector(anchor) : null;
      if (same) {
        if (typed !== null) same.value = typed;
        same.focus({ preventScroll: true });
      } else if (operated || focusFree) {
        const target = inputs[Math.min(line, inputs.length) - 1]
          || host.querySelector('.cart__link, .cart__continue-button .button');
        if (target) target.focus({ preventScroll: true });
      }

      // 読み上げ: 何が変わったか、新しい合計、空になったか
      const total = nextCart.querySelector('.cart__subtotal-price')?.childNodes[0]?.textContent.trim();
      if (nextCart.querySelector('.cart__empty-message')) {
        announce(`${title}を削除しました。カート内に商品がありません。`);
      } else if (quantity === 0) {
        announce(`${title}を削除しました。小計は${total}です。`);
      } else {
        announce(`数量を更新しました。小計は${total}です。`);
      }
    };

    // 行は位置（line）でなく key で指定する。位置で指定すると、別のタブでカートが変わっていたときや
    // 行が繰り上がったときに、別の行を巻き込むため。成功したら true、失敗（ページを読み直す）なら false を返す。
    const update = (line, key, quantity) => {
      const title = host.querySelectorAll('.cart__product-title')[line - 1]?.textContent.trim() || '商品';
      host.querySelector('.cart__container')?.setAttribute('aria-busy', 'true');
      announce('カートを更新しています。');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);
      return fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionKeys.join(','), sections_url: window.location.pathname }),
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then((cart) => {
          render(cart.sections, line, key, quantity, title);
          return true;
        })
        .catch(() => {
          // 通信・描き直しの失敗や打ち切りのときは、送り直さずにページを読み直して、いまのカートの中身を見せる。
          // （要求がサーバーに届いていたのに応答だけが返らなかった場合、送り直すと二重に処理される。
          //  すでに消えた行を指して Shopify のエラーページが出ることもある）
          try { sessionStorage.setItem('cart-reloaded', '1'); } catch (error) { /* 案内が出ないだけ */ }
          location.reload();
          return false;
        })
        .finally(() => clearTimeout(timeout));
    };

    const run = (line, key, quantity) => {
      pending += 1;
      queue = queue.then(() => update(line, key, quantity)).finally(() => { pending -= 1; });
      return queue;
    };

    // 待っている入力を、いまの DOM の行に引き直して反映する（行の位置は、その間に変わっていることがある）
    const flush = () => {
      if (!waiting) return queue;
      clearTimeout(waiting.timer);
      const { key, value } = waiting;
      waiting = null;
      const input = host.querySelector(`.cart__qty-input[data-key="${key}"]`);
      return input ? run(Number(input.dataset.line), key, value) : queue;
    };

    host.addEventListener('change', (event) => {
      const input = event.target.closest?.('.cart__qty-input');
      if (!input) return;

      const value = input.value.trim();
      const quantity = Number(value);
      if (value === '' || !Number.isInteger(quantity) || quantity < 0 || quantity > MAX_QUANTITY) {
        input.value = input.dataset.quantity; // 空・小数・範囲外は元の値に戻す
        const message = `数量は0〜${MAX_QUANTITY}で入力してください。`;
        showRowMessage(input, message);
        announce(message);
        return;
      }
      showRowMessage(input, '');
      if (String(quantity) === input.dataset.quantity) return;

      if (waiting && waiting.key !== input.dataset.key) flush();
      if (waiting) clearTimeout(waiting.timer);
      waiting = { key: input.dataset.key, value: quantity, timer: setTimeout(flush, WAIT_MS) };
    });

    host.addEventListener('click', (event) => {
      const link = event.target.closest?.('.cart__remove');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      run(Number(link.dataset.line), link.dataset.key, 0);
    });

    host.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') {
        // 数量欄で Enter を押すと、隠した「更新」ボタンの送信が来る。反映だけして、ページは動かさない
        event.preventDefault();
        if (waiting) flush();
        return;
      }
      // 数量を打った直後に「ご購入手続きへ」を押しても、反映が終わってから進む（古い数量で進まない）。
      // 反映に失敗してページを読み直しているときは、進まない。
      if (!waiting && pending === 0) return;
      event.preventDefault();
      flush().then((ok) => {
        if (ok === false) return;
        host.querySelector('.cart__form')?.requestSubmit(host.querySelector('[name="checkout"]'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // デザインの改善要望フォームの JS 強化。JS 無しでも通常の POST で送れる(Liquid 側のコメント参照)。
  (() => {
    const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    let turnstileLoading;

    function loadTurnstile() {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (!turnstileLoading) {
        turnstileLoading = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = TURNSTILE_SRC;
          script.async = true;
          script.onload = () => resolve(window.turnstile);
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      return turnstileLoading;
    }

    function showStatus(id) {
      document.querySelectorAll('.product__feedback-status').forEach((el) => {
        el.classList.toggle('is-visible', el.id === id);
      });
      const el = document.getElementById(id);
      if (el) el.focus();
    }

    document.querySelectorAll('[data-feedback]').forEach((details) => {
      const form = details.querySelector('[data-feedback-form]');
      const slot = form.querySelector('[data-turnstile]');
      const button = form.querySelector('button[type="submit"]');
      const sitekey = form.dataset.turnstileSitekey;
      let widgetId;

      // 開いたときに初めて Turnstile を読む。読めなくてもトークン無しで送れる(Worker が厳しめに制限する)
      details.addEventListener('toggle', () => {
        if (!details.open || !sitekey || widgetId !== undefined) return;
        widgetId = null;
        loadTurnstile()
          .then((turnstile) => {
            // 既定の normal は 300px 固定なので、それより狭い画面では compact(150px)にする。
            // slot 自体は空のうち display: none で幅 0 なので、フォームの幅で判定する
            const size = form.clientWidth < 300 ? 'compact' : 'normal';
            widgetId = turnstile.render(slot, { sitekey, size, theme: 'light' });
          })
          .catch(() => {});
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        button.disabled = true;
        try {
          const res = await fetch(form.action, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new URLSearchParams(new FormData(form)),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || !data.ok) throw new Error(data.error || String(res.status));
          form.reset();
          details.open = false;
          showStatus('feedback-sent');
        } catch (error) {
          showStatus('feedback-error');
        } finally {
          button.disabled = false;
          if (widgetId && window.turnstile) window.turnstile.reset(widgetId);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
